<app-detail></app-detail>